import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResultOutcomeRoutingModule } from './result-outcome-routing.module';
import { ResultOutcomePageComponent } from './components/result-outcome-page/result-outcome-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { AdminResultOutcomeComponent } from './components/admin-result-outcome/admin-result-outcome.component';


@NgModule({
  declarations: [ResultOutcomePageComponent, AdminResultOutcomeComponent],
  imports: [
    CommonModule,
    ResultOutcomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class ResultOutcomeModule { }
